import React, { useContext } from 'react';
import { Row, Col, Card, Tooltip, Spin, Avatar } from 'antd';
import { Context } from '../context';
import { Appearer } from './Appearer';
import { LinkedinFilled, GlobalOutlined, InstagramOutlined, EllipsisOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';


const { Meta } = Card;

export function LayoutGrid(props) {



  const context = useContext(Context);
  const { data } = context;

  return (
    <div>
      {data.length === 0 ? (
        <div className='_fcc _fv y _fgap2' style={{ minHeight: '80vh' }}>
          <Spin size="large" />
          <div >
            Загрузка...
          </div>
        </div>
      ) : (
        <Row gutter={16}>
          {data.map((entry, index) => (
            <Col xs={12} sm={12} md={8} lg={6} key={entry._id}>
              <Appearer order={index}>
                <AlumniCard entry={entry} />
              </Appearer>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};



const AlumniCard = ({ entry }) => {

  const navigate = useNavigate();
  // Split credits into lines and limit to 3 lines for preview
  const creditsLines = entry.alumniCredits;
  const previewCredits = creditsLines.slice(0, 2);
  // const previewCredits = "";

  return (
    <Card
      hoverable
      className='_pointer'
      bodyStyle={{ padding: "0 0 32px 0" }}
    // cover={<img alt={entry.person} src={entry.coverImage} />} // Placeholder image
    >
      <div className="_fv _fgap1 _backzoom0">
        <div className="_clickable"
          onClick={() => {
            navigate(`/@${entry.handle}`);
          }}
        />
        <div style={{ overflow: 'hidden' }}>
          <div
            className='_backzoom'
            style={{
              height: '16em',
              backgroundImage: `url(${entry.coverImage})`,
              backgroundSize: 'cover',
              backgroundPosition: '0 0',
              backgroundColor: '#2e2e2e',
            }}
          />
        </div>
        <div className="_fv _fgap08">
          <div className="_f _fm">
            <Avatar
              style={{
                backgroundColor: '#ffd20b6b',
                flexShrink: 0,
                color: '#000000',
                backgroundImage: `url(${entry.avatar})`,
                backgroundSize: 'cover',
                backgroundPosition: '0 0',
              }}
              size={36}
            >
              {entry.person.charAt(0)}
            </Avatar>
            <h3>{entry.person}</h3>
          </div>
          {/* <div>{entry.studentType}</div> */}
          <div>
            {/* Display preview of credits */}
            <div>
              {previewCredits.map(one => <div key={`preview_${one}_${entry._id}`} className='ellipsis' style={{ maxWidth: '14em' }}>{one}</div>)}
            </div>
            {creditsLines.length > 3 && (
              <Tooltip title={entry.alumniCredits} placement="top">
                <EllipsisOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
              </Tooltip>
            )}
          </div>
          <div className='_f'>
            <a
              style={{ position: 'relative', zIndex: 2 }}
              // href={entry.linkedIn}
              onClick={(e) => {
                e.stopPropagation();
                window.open(entry.linkedIn, '_blank');
              }}
              target="_blank" rel="noopener noreferrer">
              <LinkedinFilled style={{ fontSize: '16px' }} />
            </a>
            <a
              style={{ position: 'relative', zIndex: 2 }}
              // href={entry.alumniWebsite}
              onClick={(e) => {
                e.stopPropagation();
                window.open(entry.alumniWebsite, '_blank');
              }}
              target="_blank" rel="noopener noreferrer">
              <GlobalOutlined style={{ fontSize: '16px' }} />
            </a>
            <a
              style={{ position: 'relative', zIndex: 2 }}
              // href={entry.instagram}
              onClick={(e) => {
                e.stopPropagation();
                window.open(entry.instagram, '_blank');
              }}
              target="_blank" rel="noopener noreferrer">
              <InstagramOutlined style={{ fontSize: '16px' }} />
            </a>
          </div>
        </div>
      </div>
    </Card>
  );
};
